import I18n from 'i18n'
import { call, put, takeLatest } from 'redux-saga/effects'

import destroyExternalCourse from 'api/administration/externalCourseParticipants/Destroy'
import externalCourseParticipantsList, {
  ExternalCourseParticipantsListParams,
} from 'api/administration/externalCourseParticipants/GetList'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { IExternalCourseParticipant } from 'models/externalCourseParticipant.model'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'

import {
  DESTROY_EXTERNAL_COURSE_PARTICIPANT,
  Actions,
} from '../../actions/externalCourseParticipant.action'
import { joinKeys } from '../../../helpers/translations.helper'

function handleDestroy(externalCourseId: number | string) {
  return destroyExternalCourse(externalCourseId)
}
const pattern = DESTROY_EXTERNAL_COURSE_PARTICIPANT

export interface DestroyExternalCourseParticipantPayload {
  id: IExternalCourseParticipant['id'] | string
  externalCourseId?: ExternalCourseModelAPI['id'] | string
  params?: ExternalCourseParticipantsListParams
}

export type DestroyExternalCourseParticipantAction = ActionWithPayload<
  typeof pattern,
  DestroyExternalCourseParticipantPayload
>

const prefix = 'administration.externalCourses.participants.toastMessages'

function* destroyExternalCourseParticipantEffectSaga(
  action: DestroyExternalCourseParticipantAction
) {
  try {
    const { id, externalCourseId, params } = action.payload
    yield call(handleDestroy, id)
    if (externalCourseId) {
      const { data, total, perPage: resPerPage } = yield call(
        externalCourseParticipantsList,
        externalCourseId,
        params
      )
      yield put(
        Actions.setAdministrationListSuccess(
          data,
          total,
          resPerPage,
          params?.sort
        )
      )
    }
    SuccessToast(I18n.t(joinKeys(prefix, 'deleteSuccess')))
  } catch (error) {
    yield put(Actions.setLoading(false))
    ErrorToast(I18n.t(joinKeys(prefix, 'deleteError')))
    console.error('error: ', error)
  }
}

export function* destroyExternalCourseParticipantWatcherSaga() {
  yield takeLatest(pattern, destroyExternalCourseParticipantEffectSaga)
}
